import React from "react";
import GeoIcon from "../../../../assets/images/icons/geo-icon.svg";
import SearchPlus from "../../../../assets/images/icons/search-plus.svg";
import Searchbar from "./components/Searchbar";
import AudienceChart from "./components/AudienceChart";
import RadioTrackMap from "./components/RadioTrackMap";
import StarIcon from '../../../../assets/images/icons/start-icon.svg';

const RadioGeoInsightSection = ({ hasActiveSubscription, onProClick }) => {
  const [zoom, setZoom] = React.useState(1);
  const [track, setTrack] = React.useState("")

  const handleZoomIn = () => {
    setZoom((z) => Math.min(z * 1.5, 4));
  };

  const handleZoomOut = () => {
    setZoom((z) => Math.max(z / 1.5, 1));
  };

  const getTrack = (e) => {
    setTrack(e)
  }

  return (
    <div className="info-box h-full bg-theme_clr1 text-white flex flex-col justify-between rounded-xl p-4 xl:p-5">
      <div className="flex justify-between items-center gap-2 leading-tight mb-4">
        <div className="flex flex-wrap gap-2">
          <img
            src={GeoIcon}
            alt="GeoMap"
            className="inline w-[30px] h-[30px] mr-2"
          />
          <div className="title-info text-[23px] font-bold font-manrope ">
            Geo Data
          </div>
          <Searchbar
            searchPlaceholder={"Search..."}
            source={"radio"}
            period={"all"}
            onSelectTrack={getTrack}
            forMap
          />
        </div>
        <div className="flex gap-2">
          {/* Show zoom-in button always */}
          <div onClick={handleZoomIn} className="cursor-pointer">
            <img
              src={SearchPlus}
              alt="Zoom In"
              className="inline w-[30px] h-[30px]"
            />
          </div>

          {/* Show zoom-out button only when zoomed in */}
          {zoom > 1 && (
            <div onClick={handleZoomOut} className="cursor-pointer">
              <img
                src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='white' viewBox='0 0 512 512'><path d='M208 0C93.1 0 0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.5 128-44l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L381.3 326.6c27.5-35.3 44-79.7 44-128C425.3 93.1 332.2 0 208 0zM128 192h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z'/></svg>"
                width="30"
                height="30"
                alt="Search Minus Icon"
              />
            </div>
          )}
        </div>
      </div>
      <div className="relative w-full h-full min-h-[400px]">
        {hasActiveSubscription ?
          track !== "" ? (
            <RadioTrackMap zoom={zoom} setZoom={setZoom} />
          ) : (
            <AudienceChart zoom={zoom} setZoom={setZoom} />
          ) :
          <>
            {/* Greyed Out Overlay */}
            <div className="absolute inset-0 bg-gray-200/30 backdrop-blur-[2px] z-10 rounded" />
            <img src={require('../../../../assets/images/world-map.png')} />
            {/* Go Pro Button */}
            <div className="absolute inset-0 z-20 flex items-center justify-center">
              <button
                type="button"
                className={`btn-custom3 flex items-center gap-2`}
                onClick={onProClick}
              >
                Go Pro
                <img
                  src={StarIcon}
                  alt="Star"
                  className="h-[20px] w-[20px] min-w-[20px]"
                />
              </button>
            </div>
          </>
        }
      </div>
    </div>
  );
};

export default RadioGeoInsightSection;
